import handleAuthError from './authMiddleware'
import { showModalMessage } from '../layout'
import { createCollectionRequest } from '../../utils/user'
import { logError } from '../../utils/errors'
import { reportCollectionCreated } from '../../analytics/userAnalytics'

const createCollectionRequestAction = { type: 'createCollectionRequest' }
const createCollectionSuccessAction = response => {
  reportCollectionCreated()
  return {
    type: 'createCollectionSuccess',
    payload: response
  }
}
const createCollectionFailureAction = (name, isPublic) => ({
  type: 'createCollectionFailure',
  payload: { name, isPublic }
})

export const createCollection = ({
  name,
  isPublic = false,
  description,
  specialRole
}) => {
  return async (dispatch, getState) => {
    const { user: { token } } = getState()
    if (!token) return dispatch(createCollectionFailureAction(name, isPublic))

    dispatch(createCollectionRequestAction)

    try {
      const response = await createCollectionRequest(token, {
        name,
        isPublic,
        description,
        specialRole
      })
      return dispatch(createCollectionSuccessAction(response))
    } catch (err) {
      if (err.statusCode === 401) {
        return dispatch(
          handleAuthError(
            createCollection({
              name,
              isPublic,
              description,
              specialRole
            })
          )
        )
      } else {
        logError(err)
        return dispatch(
          showModalMessage({ message: 'Create collection failed' })
        )
      }
    }
  }
}

export const createFavoriteCollection = () => {
  return createCollection({
    name: 'My Favorites',
    isPublic: 'false',
    description: 'Items you marked as your favorites.',
    specialRole: 'favorite'
  })
}



// WEBPACK FOOTER //
// ./common/actions/user/collection.js